import { apiClient } from './client'

/**
 * Объявления для сотрудников — сообщения из «Пульта проектов»: плановые
 * работы, новая возможность, важное напоминание. Кому и когда показывать,
 * решает сервер; интерфейс только рисует и отмечает «закрыл».
 */

export type AnnouncementLevel = 'INFO' | 'WARNING' | 'CRITICAL'
export type AnnouncementDisplay = 'BANNER' | 'MODAL'

export interface ActiveAnnouncement {
  id: string
  title: string
  body: string
  level: AnnouncementLevel
  display: AnnouncementDisplay
  /** Окно показа в ISO; пусто — без ограничения. */
  startsAt: string
  endsAt: string
}

export async function getActiveAnnouncements(): Promise<ActiveAnnouncement[]> {
  const res = await apiClient.get<{ success: true; data: ActiveAnnouncement[] }>(
    '/announcements/active',
  )
  return res.data.data
}

export async function dismissAnnouncement(id: string): Promise<void> {
  await apiClient.post(`/announcements/${id}/dismiss`)
}
